/* global dicoKeys */

/**
 *  Social Share
 */

import GlobalVars from '../GlobalVars';
import AjaxURL from '../AjaxURL';
import { btnLoader } from '../../common/Utils';
import { triggerSocialFollowClickEvent, triggerProductSocialViralityEvent } from '../Events';
import { getOneTrustClassByTag, isOneTrustEnable } from '../tools/OneTrustTagging';

// Share to friend popup const
let emailsArray = [];
const $popinErrorMsg = $('#popinErrorMsg');
const $popinValidMsg = $('#popinValidMsg');
const $shareFriendEmails = $('#shareFriendEmails');
const $shareFriendMessage = $('#shareFriendMessage');
const loader = btnLoader('.a-spinner--btn-loader', {
  textCont: 'span'
});
const maxEmailsNb = 4;
let currentEmailsNb = 0;

function validateEmail($email) {
  const emailReg = /^([\w-.]+@([\w-]+\.)+[\w-]{2,4})?$/;
  return emailReg.test($email);
}

function removeEmailInput(line) {
  const inputToRemove = $(line).parent('.o-popin-share-friend__input-line').first();
  if (currentEmailsNb > 0) {
    inputToRemove.remove();
    currentEmailsNb -= 1;
  }
}

function addNewEmailInput() {
  const newEmailLine = `
  <div class="o-popin-share-friend__input-line">
    <div class="o-popin-share-friend__input m-private-input">
      <label class="m-private-input__title m-private-input__title--mandatory a-label a-label--italic">${dicoKeys.SendToFriendToEmail}<span class="m-private-input__star">*</span></label>
      <input type="text" class="m-private-input__input" name="friends[]" required />
    </div>
    <button type="button" aria-hidden="true" aria-label="${dicoKeys.removeEmail}" class="o-popin-share-friend__remove-email">-</button>
  </div>`;
  if (currentEmailsNb < maxEmailsNb) {
    $shareFriendEmails.append(newEmailLine);
    currentEmailsNb += 1;
  }
  $('.o-popin-share-friend__remove-email').on('click', function removeEmail() {
    removeEmailInput($(this));
  });
}

function shareWishList() {
  loader.toggle();
  $popinErrorMsg.hide();
  $popinValidMsg.hide();
  emailsArray = [];

  // Add every input's value to email arrays
  $shareFriendEmails.find('input[name="friends[]"]').each((index, elem) => {
    const email = $(elem).val();
    if (validateEmail(email)) {
      emailsArray.push($(elem).val());
    }
  });

  if (emailsArray.length > 0 && $shareFriendMessage.val() !== '') {
    console.log('success');
    // Send emails request
    $.ajax({
      url: AjaxURL.shareToFriends,
      data: {
        c: GlobalVars.C,
        l: GlobalVars.L,
        task: 'sendmail_whishlist',
        to_email: emailsArray.join(','),
        message: $shareFriendMessage.val(),
        page_url: dicoKeys.publicUrl
      },
      type: 'post',
      dataType: 'json',
    }).done((data) => {
      loader.toggle();
      if (data.success) {
        console.log(data);
        $popinErrorMsg.hide();
        $popinValidMsg.show();
      } else {
        // console.log('error');
        $popinErrorMsg.show();
        $popinValidMsg.hide();
      }
    })
    .fail(() => {
      // console.log('error');
      loader.toggle();
      $popinErrorMsg.show();
      $popinValidMsg.hide();
    });
  } else {
    loader.toggle();
    $popinErrorMsg.show();
    $popinValidMsg.hide();
  }
}

function initShareWishList() {
  $('.js-SocialShareBtn').on('click', () => {
    const $socialShareContent = $('.js-SocialShareContent');

    if (!$socialShareContent.length) {
      return;
    }

    $socialShareContent.slideToggle(300, () => {
      $socialShareContent.attr('aria-hidden', $socialShareContent.is(':visible'));
    });
  });

  $('#shareToFriendBtn').on('click', function shareToFriend() {
    if ($(this).data('sharingtype') === 'wishlist') {
      shareWishList();
    }
  });

  $('#popinAddEmailBtn').on('click', () => {
    addNewEmailInput();
  });
}

function initFacebook(d, s, id, params = {}) {
  $.extend({
    async: false,
    defer: false,
  }, params);

  // if ($('.fb-like').length > 0 || $('[id$="fbLike"]').length > 0 || $('[id$="fbShare"]').length > 0) {
  const currentCulture = GlobalVars.Culture.replace('-', '_');
  const fjs = d.getElementsByTagName(s)[0];
  if (d.getElementById(id)) return;
  const js = d.createElement(s);
  if (params.async) {
    js.async = true;
  } else if (params.defer) {
    js.defer = true;
  }
  if (isOneTrustEnable()) {
    js.type = 'text/plain';
    js.class = getOneTrustClassByTag('facebook');
  }
  js.id = id;
  js.src = `//connect.facebook.net/${currentCulture}/sdk.js`;
  fjs.parentNode.insertBefore(js, fjs);
  // }
}

// TWITTER
function handleTwitterAction() {
  const twttr = window.twttr;

  twttr.ready(() => {
    twttr.events.bind('tweet', () => {
      triggerSocialFollowClickEvent({
        name: 'twitter',
        interaction: 'tweet',
      });
    });
  });
}

function initTwitter(d, s, id) {
  if ($('[id$="twitterBtn"]').length > 0) {
    const fjs = d.getElementsByTagName(s)[0];
    const p = /^http:/.test(d.location) ? 'http' : 'https';
    if (!d.getElementById(id)) {
      const js = d.createElement(s);
      js.id = id;
      js.src = p.concat('://platform.twitter.com/widgets.js');
      fjs.parentNode.insertBefore(js, fjs);
    }
    if (GlobalVars.CurrentTemplate === 'MyAccountBrandWishlist') {
      $(window).on('load', () => {
        handleTwitterAction();
      });
    }
  }
}

function initGplus() {
  if ($('[id$="gplusBtn"]').length > 0 || $('.g-plus').length > 0) {
    let htmlScript = '<script src="https://apis.google.com/js/platform.js" async defer></script>';
    if (isOneTrustEnable()) {
      const classTag = getOneTrustClassByTag('googlePlus');
      htmlScript = `<script type="text/plain" class="${classTag}" src="https://apis.google.com/js/platform.js" async defer></script>`;
    }
    $('body').append(htmlScript);
  }
}

function initPinterest() {
  if ($('[id$="pinIt"]').length > 0) {
    let htmlScript = '<script type="text/javascript" async defer src="//assets.pinterest.com/js/pinit.js"></script>';
    if (isOneTrustEnable()) {
      const classTag = getOneTrustClassByTag('pinterest');
      htmlScript = `<script type="text/plain" class="${classTag}" async defer src="//assets.pinterest.com/js/pinit.js"></script>`;
    }
    $('body').append(htmlScript);
  }
}

function fbFooterActionCallback(aAction) {
  const socialNetworkName = 'facebook';
  const socialAction = aAction !== '' ? aAction : 'follow';

  triggerSocialFollowClickEvent({
    name: socialNetworkName,
    interaction: socialAction,
  });
}

function fbProductPageActionCallback() {
  triggerProductSocialViralityEvent({
    name: 'facebook',
    product: OCMS.productpage != null ? OCMS.productpage.ProductTitle : 'None',
    sku: OCMS.productpage != null ? OCMS.productpage.sku : 'None'
  });
}

function handleFbFollow() {
  // Define the async init facebook callback.
  const oldFbAsyncInit = window.fbAsyncInit;
  window.fbAsyncInit = () => {
    const FB = window.FB;
    const isProductPage = OCMS.productpage != null && OCMS.productpage.pageTemplate === 'Product'
      && OCMS.productpage.pageArticleId != null;

    if (oldFbAsyncInit != null) {
      oldFbAsyncInit.call();
    } else {
      FB.init({
        appId: '384812148242929',
        xfbml: true,
        status: true,
        version: 'v2.10'
      });
    }

    if (!FB.EdgeEventSubscribed) {
      FB.Event.subscribe('edge.create', (taggedUrl) => {
        // It's a like
        if (isProductPage && taggedUrl.indexOf(`a=${OCMS.productpage.pageArticleId}`) > 0) {
          fbProductPageActionCallback();
        } else {
          fbFooterActionCallback('like');
        }
      });
      // It's an unlike
      FB.Event.subscribe('edge.remove', (taggedUrl) => {
        if (isProductPage && taggedUrl.indexOf(`a=${OCMS.productpage.pageArticleId}`) > 0) {
          fbProductPageActionCallback();
        } else {
          fbFooterActionCallback('unlike');
        }
      });
      FB.EdgeEventSubscribed = true;
    }
  };
  // Init FB SDK
  initFacebook(document, 'script', 'facebook-jssdk', { async: true });
}

function init() {
  initShareWishList();
  initTwitter(document, 'script', 'twitter-wjs');
  initPinterest();
  initGplus();
}


export {
  init,
  initFacebook,
  handleFbFollow,
};

export default init;



// WEBPACK FOOTER //
// ./js/common/molecule/social-share.js